// Weighted scoring helpers shared across screens. Response weights and the set
// of counting responses now come from the shared response-set config so that
// alternate response sets (good/fair/poor, pass/fail, etc.) score correctly.
import { RESPONSE_WEIGHT, COUNTING_RESPONSES } from "./responseSets";

export { RESPONSE_WEIGHT, COUNTING_RESPONSES };

export function computeScore(responses, checklist) {
  let evaluated = 0;
  let obtained = 0;
  const byCat = {};
  const byTpl = {};
  const responseMap = new Map(responses.map((r) => [r.question_id, r]));
  for (const q of checklist) {
    const r = responseMap.get(q.id);
    if (!r) continue;
    if (!COUNTING_RESPONSES.has(r.response)) continue; // skip na / unknown
    const w = q.weight || 1;
    const factor = RESPONSE_WEIGHT[r.response] ?? 0;
    evaluated += w;
    obtained += w * factor;
    const cat = q.category || "—";
    if (!byCat[cat]) byCat[cat] = { obtained: 0, evaluated: 0 };
    byCat[cat].evaluated += w;
    byCat[cat].obtained += w * factor;
    const tpl = q.template || "Tienda";
    if (!byTpl[tpl]) byTpl[tpl] = { obtained: 0, evaluated: 0 };
    byTpl[tpl].evaluated += w;
    byTpl[tpl].obtained += w * factor;
  }
  // Score is clamped to [0, 100] for display, but obtained can dip negative if Multa is heavy.
  const rawScore = evaluated ? (obtained / evaluated) * 100 : 0;
  const score = Math.max(0, Math.min(100, rawScore));
  const buildItems = (map) =>
    Object.entries(map).map(([key, v]) => {
      const subtotal = v.evaluated ? Math.max(0, Math.min(100, (v.obtained / v.evaluated) * 100)) : 0;
      return {
        key,
        category: key,
        obtained: v.obtained,
        evaluated: v.evaluated,
        subtotal,
        semaforo:
          v.evaluated === 0
            ? "gris"
            : subtotal >= 85
            ? "verde"
            : subtotal >= 70
            ? "amarillo"
            : "rojo",
      };
    });
  return {
    score: Math.round(score * 10) / 10,
    raw_score: Math.round(rawScore * 10) / 10,
    obtained,
    evaluated,
    categories: buildItems(byCat),
    templates: buildItems(byTpl),
    semaforo:
      evaluated === 0
        ? "gris"
        : score >= 85
        ? "verde"
        : score >= 70
        ? "amarillo"
        : "rojo",
  };
}

export function semaforoLabel(s) {
  return { verde: "Verde", amarillo: "Amarillo", rojo: "Rojo", gris: "Sin datos" }[s] || s;
}
